// Configuration de campagne promotionnelle — bannière d'accueil.
//
// Objectif : composant 100% piloté par la config ci-dessous, réutilisable pour
// n'importe quel futur événement (Ligue des Champions, Coupe du Monde, Black
// Friday...). Pour lancer une nouvelle campagne : dupliquer/adapter cet objet
// (dates, montants, code, texte) — aucune modification du composant nécessaire.
//
// ⚠️ Le code promo (`promoCode`) doit correspondre à un document actif dans la
// collection MongoDB `promo_codes_unique` (voir /app/backend/campaign_ligue1_seed.py)
// pour que la réduction s'applique réellement au paiement. Garder les dates et
// montants des `phases` ci-dessous IDENTIQUES à ceux du seed backend.

export const CAMPAIGN = {
  // Interrupteur général : passer à false pour désactiver la bannière instantanément.
  enabled: true,

  id: 'ligue1_reprise_2026',

  eventEmoji: '🏆',
  eventName: 'Ligue 1',
  eventTitle: 'La Ligue 1 revient le 21 août !',
  // Date de référence de l'événement (reprise du championnat) affichée en badge.
  eventDate: '2026-08-21T21:00:00+02:00',
  eventDateLabel: '21 août',

  subtitleLines: [
    'Ne manquez aucun match avec IPTV4KFR.',
    "Profitez de notre offre exceptionnelle avant la reprise du championnat.",
  ],

  promoCode: 'LIGUE12026-27',

  ctaPrimary: { label: "Profiter de l'offre", to: '/offre' },
  ctaSecondary: { label: 'Voir les formules', to: '/offre' },

  // Phases successives de la promotion. Le composant sélectionne automatiquement
  // la phase active selon la date/heure actuelle, et bascule de l'une à l'autre
  // sans rechargement de page.
  phases: [
    {
      id: 'phase1',
      label: 'Phase 1',
      start: '2026-08-07T00:00:00+02:00',
      end: '2026-08-14T23:59:59+02:00',
      discountEuros: 20,
      spotsTotal: 20,
      // Nombre d'accès restants — variable à ajuster manuellement pour piloter
      // l'effet de rareté affiché (indépendant du suivi réel des ventes).
      spotsRemaining: 20,
    },
    {
      id: 'phase2',
      label: 'Phase 2',
      start: '2026-08-15T00:00:00+02:00',
      end: '2026-08-20T23:59:59+02:00',
      discountEuros: 10,
      spotsTotal: 50,
      spotsRemaining: 50,
    },
  ],
};

export default CAMPAIGN;
